// extracted by mini-css-extract-plugin
export default {"previewData":"OfferAccordion_previewData__6CXtr","previewData__cell":"OfferAccordion_previewData__cell__4cVgh","previewData__title":"OfferAccordion_previewData__title__VauL6"};